import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { fmtMoney } from "@/lib/format";

// Lines are edited as text fields; { description, qty, price } where price is dollars.
export const toEditLines = (lines) => lines.map((l) => ({ description: l.description, qty: String(l.qty), price: (l.unit_c / 100).toFixed(2) }));
export const fromEditLines = (rows) => rows.map((r) => ({ description: r.description.trim(), qty: Number(r.qty), unit_c: Math.round(Number(r.price) * 100) }));
export const lineCents = (r) => Math.round((Number(r.qty) || 0) * Math.round((Number(r.price) || 0) * 100));

export const LinesEditor = ({ rows, setRows, items = [], disabled }) => {
  const set = (i, k, v) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const add = (description = "", price = "0.00") => setRows([...rows, { description, qty: "1", price }]);
  return (
    <div className="space-y-2" data-testid="invoice-lines">
      <div className="hidden sm:grid grid-cols-[1fr_70px_100px_90px_32px] gap-2 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground px-1">
        <span>Description</span><span className="text-right">Qty</span><span className="text-right">Unit price</span><span className="text-right">Amount</span><span />
      </div>
      {rows.map((r, i) => (
        <div key={i} className="grid grid-cols-[1fr_70px_100px] sm:grid-cols-[1fr_70px_100px_90px_32px] gap-2 items-center" data-testid={`invoice-line-${i}`}>
          <Input value={r.description} disabled={disabled} onChange={(e) => set(i, "description", e.target.value)} placeholder="Description" data-testid={`invoice-line-desc-${i}`} className="col-span-3 sm:col-span-1" />
          <Input value={r.qty} disabled={disabled} inputMode="decimal" onChange={(e) => set(i, "qty", e.target.value)} className="text-right" data-testid={`invoice-line-qty-${i}`} />
          <Input value={r.price} disabled={disabled} inputMode="decimal" onChange={(e) => set(i, "price", e.target.value)} className="text-right" data-testid={`invoice-line-price-${i}`} />
          <span className="text-right text-sm font-medium tabular-nums" data-testid={`invoice-line-amount-${i}`}>{fmtMoney(lineCents(r))}</span>
          {disabled ? <span className="hidden sm:block" /> : (
            <Button type="button" variant="ghost" size="icon" disabled={rows.length === 1} onClick={() => setRows(rows.filter((_, j) => j !== i))}
              data-testid={`invoice-line-remove-${i}`} className="h-8 w-8 rounded-full text-muted-foreground hover:text-destructive"><Trash2 className="w-4 h-4" /></Button>
          )}
        </div>
      ))}
      {!disabled && (
        <div className="flex flex-wrap gap-2 pt-1">
          <Button type="button" variant="outline" size="sm" onClick={() => add()} className="rounded-full" data-testid="invoice-add-line"><Plus className="w-3.5 h-3.5 mr-1" /> Add line</Button>
          {items.map((it, i) => (
            <Button key={i} type="button" variant="ghost" size="sm" onClick={() => add(it.description, Number(it.price).toFixed(2))}
              className="rounded-full bg-secondary/70 hover:bg-secondary" data-testid={`invoice-add-item-${i}`}>+ {it.description} · {fmtMoney(Math.round(it.price * 100))}</Button>
          ))}
        </div>
      )}
    </div>
  );
};
